module.exports = __webpack_public_path__ + "static/sfv-match-b8667bdbf092354da5e4e14dbaf56859.png";